function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "8722DF04-0625-4A0D-9085-D59D9AD7B38B");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Admissions",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "anuAdmissionsGeneralInfoMobile",
  transform: "translate(-340.000000, -6.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "headerMobile"
}, /*#__PURE__*/React.createElement("g", {
  id: "infoBar"
}, /*#__PURE__*/React.createElement("g", {
  id: "gropLogOut",
  transform: "translate(278.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.25,5 C64.6642138,5 65,5.41973281 65,5.93749999 C65,6.45526717 64.6642138,6.875 64.25,6.87499998 L64.25,6.87499998 L63.5,6.87500012 L63.5,18.125 L64.2499999,18.125 C64.6642137,18.125 65,18.5447328 65,19.0625 C65,19.5802672 64.6642137,20 64.2499999,20 L64.2499999,20 L62.75,20 C62.3357862,20 62,19.5802672 62,19.0625 L62,19.0625 L62,5.93749999 L62,5.93749999 L62.0058436,5.81990194 C62.0521235,5.35764216 62.3676488,5 62.75,5 L62.75,5 Z M74.0720659,8.10441303 C74.4729748,7.89556835 74.9787544,8.0064811 75.2480931,8.37928696 L75.2480931,8.37928696 L77.8324952,11.9787519 C78.06242,12.2988862 78.0550077,12.7282929 77.8141661,13.0405929 L77.8141661,13.0405929 L75.0648019,16.6400539 C74.8917257,16.8666454 74.6200986,17 74.331638,17 L74.331638,17 L74.2135356,16.9924977 C74.0575392,16.9725928 73.9086729,16.9134848 73.7817652,16.820027 L73.7817652,16.820027 L73.694083,16.7466919 C73.3665075,16.4360486 73.3181483,15.9272178 73.5984743,15.5602157 L73.5984743,15.5602157 L75.2480929,13.4005391 L67.9164548,13.4005391 C67.4103105,13.4005391 67,12.9976559 67,12.5006739 C67,12.0036918 67.4103105,11.6008086 67.9164548,11.6008086 L67.9164548,11.6008086 L75.3305738,11.6008086 L73.7542716,9.42313471 C73.7527096,9.42098639 73.7511572,9.41883133 73.7496145,9.41666961 C73.4591551,9.00966325 73.559715,8.44852078 73.974221,8.16331929 L73.974221,8.16331929 Z",
  id: "icon"
}))))));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.55c26c8b.svg";
export { ForwardRef as ReactComponent };